import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { API_IDS } from '@intigral/constant';
import {
    IChannelHistoryParams,
    IChannelHistoryResponse,
    ISeriesHistoryParams,
    ISeriesHistoryResponse,
    GetKidHistoryResponse,
} from '../../entity/interface/iChannelSeriesHistory';
import { IChannelSeriesHistoryRepository } from '../../core/repositories/interfaces/iChannelSeriesHistoryRepository';
import { container } from '../../DataDomain';
import { IApiPathManager } from '../config/ApiPathManager';
import { DI } from '@intigral/constant/config/DIContainer';

class ChannelSeriesHistoryRepository implements IChannelSeriesHistoryRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getChannelHistory(
        apiKey: string,
        profileName: string,
        paylod: IChannelHistoryParams,
        token: string,
        identityToken: string
    ): Promise<IChannelHistoryResponse> {
        const path = this.apiPathManager.getPath(API_IDS.CHANNELS_HISTORY);
        const response = await this.http.get<IChannelHistoryResponse>(path, {
            params: {
                ...paylod,
                apikey: apiKey,
                profileName: profileName,
            },
            headers: {
                Authorization: token,
                identityToken: identityToken,
            },
        });
        return response.data;
    }

    async getSeriesHistory(
        apiKey: string,
        profileName: string,
        paylod: ISeriesHistoryParams,
        token: string,
        identityToken: string
    ): Promise<ISeriesHistoryResponse> {
        const path = this.apiPathManager.getPath(API_IDS.SERIES_HISTORY);
        const response = await this.http.get<ISeriesHistoryResponse>(path, {
            params: {
                ...paylod,
                apiKey: apiKey,
                profileName: profileName,
            },
            headers: {
                Authorization: token,
                identityToken: identityToken,
            },
        });
        return response.data;
    }

    async getProfileWatchesHistory(
        apiKey: string,
        profileName: string,
        userName: string,
        pageNumber: number,
        pageSize: number,
        identityToken: string
    ): Promise<GetKidHistoryResponse> {
        const path = this.apiPathManager.getPath(API_IDS.PROFILE_WATCH_HISTORY);
        const response = await this.http.get<GetKidHistoryResponse>(path, {
            params: {
                apikey: apiKey,
                profileName,
                userName,
                pageNumber,
                pageSize,
            },
            headers: {
                identityToken: identityToken,
            },
        });
        return response.data;
    }
}

export default ChannelSeriesHistoryRepository;
